import { reactive } from '@vue/composition-api'

/** 企业会员联系客服配置。默认使用刘壮熊的联系 可在阿波罗配置（has_pdf_enterprise_tab） */
export const cnterpriseState = reactive({
  /** 企业会员联系二维码 */
  qr_code: 'http://newvip-cdn.zhhainiao.com/public/activity/20220601/20220601-151224.png',
  /** 联系电话 */
  phone: '13450457270111'
})
